<div class="yes-no-field">
    @if (label) {
        <label class="yes-no-label">{{ label | translate }}</label>
    }
    <div class="yes-no-options">
        <button
            type="button"
            class="yes-no-btn"
            [class.is-active-yes]="value === true"
            [disabled]="disabled"
            (click)="select(true)"
        >
            @if (value === true) {
                <img class="yes-no-icon" src="assets/images/Vector-yes.svg" alt="" />
            }
            {{ 'yes' | translate }}
        </button>
        <button
            type="button"
            class="yes-no-btn"
            [class.is-active-no]="value === false"
            [disabled]="disabled"
            (click)="select(false)"
        >
            @if (value === false) {
                <img class="yes-no-icon" src="assets/images/Vector-no.svg" alt="" />
            }
            {{ 'no' | translate }}
        </button>
    </div>
</div>
